/**
 * 指标编辑弹窗
 */

import React, { useEffect } from 'react';
import { Modal, Form, Input, Switch, InputNumber, Space, message, Select, Row, Col } from 'antd';
import { KPIDimension, kpiDimensionService } from '../../../services/administrationService';

interface DimensionEditModalProps {
    visible: boolean;
    editingDim: KPIDimension | null;
    onCancel: () => void;
    onSuccess: () => void;
}

const DimensionEditModal: React.FC<DimensionEditModalProps> = ({
    visible,
    editingDim,
    onCancel,
    onSuccess
}) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible && editingDim) {
            form.setFieldsValue(editingDim);
        } else {
            form.resetFields();
            form.setFieldsValue({
                is_active: true,
                is_higher_better: true,
                max_score: 100,
                sort_order: 0
            });
        }
    }, [visible, editingDim, form]);

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            if (editingDim) {
                await kpiDimensionService.update(editingDim.id, values);
                message.success('更新成功');
            } else {
                await kpiDimensionService.create(values);
                message.success('创建成功');
            }
            onSuccess();
        } catch (error) {
            console.error(error);
            message.error('保存失败');
        }
    };

    return (
        <Modal
            title={editingDim ? "编辑指标" : "新增指标"}
            open={visible}
            onOk={handleSave}
            onCancel={onCancel}
        >
            <Form form={form} layout="vertical">
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="name" label="指标名称" rules={[{ required: true }]}>
                            <Input placeholder="例：销售额" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="category" label="指标分类">
                            <Select placeholder="选择分类">
                                <Select.Option value="FINANCE">财务/业绩</Select.Option>
                                <Select.Option value="OPERATION">运营/销售</Select.Option>
                                <Select.Option value="SUPPLY_CHAIN">供应链/物流</Select.Option>
                                <Select.Option value="MARKETING">市场/推广</Select.Option>
                                <Select.Option value="PRODUCT">产品/研发</Select.Option>
                                <Select.Option value="DESIGN">设计/视觉</Select.Option>
                                <Select.Option value="CUSTOMER_SERVICE">客服/体验</Select.Option>
                                <Select.Option value="MANAGEMENT">综合管理</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item name="code" label="指标代码" rules={[{ required: true }]}>
                    <Input placeholder="例：sales_amount" disabled={!!editingDim} />
                </Form.Item>
                <Form.Item name="description" label="说明">
                    <Input.TextArea rows={2} />
                </Form.Item>
                <Form.Item name="max_score" label="上限分数" rules={[{ required: true }]}>
                    <InputNumber min={0} max={1000} placeholder="默认100" style={{ width: '100%' }} />
                </Form.Item>
                <Space size="large">
                    <Form.Item name="is_active" valuePropName="checked" label="启用状态">
                        <Switch />
                    </Form.Item>
                    <Form.Item name="is_higher_better" valuePropName="checked" label="越高越好">
                        <Switch />
                    </Form.Item>
                </Space>
                <Form.Item name="sort_order" label="排序">
                    <InputNumber min={0} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default DimensionEditModal;
